<template>
    <div class="app-wrap">
        <pub-header :headTitle="'发布需求'"></pub-header>
        <div class="content-wrap release-result">
            <img class="front" src="../../../assets/images/release/release_front.jpg">
            <img src="../../../assets/images/release/release_title2.png" v-if="platform && platform==2">
            <img src="../../../assets/images/release/release_title.png" v-else>
            <img class="handle" src="../../../assets/images/release/release_handle.png" @click="handle">
            <img class="foot" src="../../../assets/images/release/release_foot.png">
        </div>
        <transition name="trade-in">
            <dialog-alert v-if="alert.isshow" :options="alert"></dialog-alert>
        </transition>
    </div>
</template>
<script>
export default {
    data(){
        return {
            alert: {
                isshow: false,
            },
            jobId: this.$route.query.jobId,
            orderNum: this.$route.query.orderNum,
            platform: this.$route.query.platform, //平台: 2:客户经理端
            userType: this.$route.query.ut ? parseInt(this.$route.query.ut) : 0, //用户类型: 0|空:客户, 2:管家
            userId: this.$route.query.uid ? this.$route.query.uid : null, //用户Id(极光Code)
        }
    },
    mounted(){
        this.init();
    },
    watch: {
        '$route': function (to, from) {
            if (to && to.name === 'releaseResult'){
                this.init();
            }
        }
    },
    methods:{
        init(){
            this.jobId = this.$route.query.jobId;
            this.orderNum = this.$route.query.orderNum;
            this.platform = this.$route.query.platform;
            this.userType = this.$route.query.ut ? parseInt(this.$route.query.ut) : 0;
            this.userId = this.$route.query.uid ? this.$route.query.uid : null;
            if(!this.userId || this.userId==0 || this.userId==""
            || this.userId==null || this.userId=="null" || this.userId==undefined || this.userId=="undefined"){
                this.userId = null;
            }
        },
        handle(){
            let self = this;
            let skipPath = "/myOrder/1";
            let params = {};
            if(self.platform && self.platform == 2){ //经理端
                skipPath = "/release/clientJobList/1";
            } else { //客户端
                params.ut = self.userType;
                params.uid = self.userId;
            }
            self.$router.push({
                path: skipPath,
                query: params
            });
            // console.log("跳转订单列表");
        },
    }
}
</script>
<style scoped>
.release-result{
    width: 100%;
}
.release-result .front{
    width: 100%;
    margin: 1rem auto 0;
}
.release-result .handle{
    width: 90%;
    margin: 0.6rem auto;
}
.release-result .foot{
    width: 84%;
    margin: 0.6rem auto;
}
</style>



// WEBPACK FOOTER //
// src/shared/components/client/release/result.vue